"use strict";

module.exports = function (fn) {
  var didCall = false;
  var returnValue;
  return function () {
    if (didCall) {
      return returnValue;
    }

    returnValue = fn.apply(void 0, arguments);
    didCall = true;
    return returnValue;
  };
};


// WEBPACK FOOTER //
// ../node_modules/@sanity/client/lib/util/once.js